import { AnalyticsEnvObject } from "../types/analytics";
import { ApiEnvObject } from "../types/api";
import { CoreEnvObject } from "../types/core";
import { PaymentEnvObject } from "../types/payment";
import { ThirdPartyEnvObject } from "../types/third-party";

/**
 * Loader for environment variables.
 * Takes all config objects that are loaded from the environment variables and returns them as a single object.
 */
export function loadEnvConfig() {
    return {
        core: CoreEnvObject,
        api: ApiEnvObject,
        analytics: AnalyticsEnvObject,
        payment: PaymentEnvObject,
        thirdParty: ThirdPartyEnvObject,
    };
}
